import * as React from 'react';
import { Dispatch } from 'react-redux';

import { HeaderButton } from '../Header/styles';
import Utils from '../../../utils';
import { StoreState } from '../../../reducers';
import { getPublicationSettings, toggleSettingsPanel } from '../../../containers/Editor/actions';
import EditPanel from '../../../containers/Editor/EditPanel';
import { AdditionalPanelType } from '../EditPanel/constants';
import SettingsPanel from '../../../containers/Editor/EditPanel/SettingsPanel';
import { EditableType, SETTINGS_PANEL_CLASSNAME } from '../../../containers/Editor/constants';
import ThemesPanel from '../../../containers/Editor/EditPanel/ThemesPanel';

interface ButtonSettingsProps {
	publicationId: number;
	isActive: boolean;
	isDisabled: boolean;
	hasPublicationSettings: boolean;
	hasThemes: boolean;
	dispatch: Dispatch<StoreState>;
}

const ButtonSettings = ({
	publicationId,
	isActive,
	isDisabled,
	hasPublicationSettings,
	hasThemes,
	dispatch,
}: ButtonSettingsProps) => {
	const buttonElement = React.useRef<HTMLButtonElement>(null);

	React.useEffect(() => {
		if (hasPublicationSettings) {
			dispatch(getPublicationSettings(publicationId));
		}
	}, [hasPublicationSettings, publicationId]);

	React.useEffect(() => {
		if (!isActive) {
			return;
		}

		const handleClickOutside = (e: MouseEvent | TouchEvent) => {
			if (e.target === buttonElement.current) {
				return;
			}

			const elementsToCheck = document.querySelectorAll(`.${SETTINGS_PANEL_CLASSNAME}`);

			if ([...elementsToCheck].every(element => !element.contains(e.target as HTMLElement))) {
				dispatch(toggleSettingsPanel());
			}
		};

		window.addEventListener('pointerdown', handleClickOutside);

		return () => {
			window.removeEventListener('pointerdown', handleClickOutside);
		};
	}, [isActive]);

	const panels = {};

	if (hasPublicationSettings) {
		panels[AdditionalPanelType.settings] = <SettingsPanel />;
	}

	if (hasThemes) {
		panels[EditableType.themes] = <ThemesPanel className={SETTINGS_PANEL_CLASSNAME} />;
	}

	return (
		<>
			<HeaderButton
				ref={buttonElement}
				iconWidth="35px"
				iconHeight="35px"
				disabled={isDisabled}
				onClick={() => dispatch(toggleSettingsPanel())}
			>
				{Utils.getSvgIcon('iconset_uprez_settings')}
			</HeaderButton>
			{isActive &&
				<EditPanel
					className={SETTINGS_PANEL_CLASSNAME}
					defaultType={hasPublicationSettings ? AdditionalPanelType.settings : EditableType.themes}
					panels={panels}
				/>
			}
		</>
	);
};

export default ButtonSettings;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ButtonSettings/index.tsx